export default __webpack_public_path__ + "static/media/hero__image.da23f8fb.webp";